/**
 * Centralised polling interval constants for all dashboard pages.
 * Replaces scattered magic numbers with named tiers.
 */
export const POLLING_INTERVALS = {
  /** PM Dashboard tiers */
  PM: {
    FAST: 10_000, // Live feed, pending walk-ins
    MEDIUM: 30_000, // Stats, incidents, upcoming visitors
    SLOW: 60_000, // Gates, devices
  },
  /** SuperAdmin Dashboard */
  SUPER_ADMIN: {
    HEALTH: 30_000,
    JOBS: 30_000,
    INCIDENTS: 60_000,
  },
  /** OrgAdmin Dashboard */
  ORG_ADMIN: {
    DASHBOARD: 60_000,
  },
  /** Resident HomePage */
  RESIDENT: {
    WALK_IN_PENDING: 30_000,
  },
  /** Guards list */
  GUARDS: {
    LIST: 30_000,
  },
} as const;

export type PollingTier = typeof POLLING_INTERVALS;
